import {createRouter, createWebHistory} from 'vue-router';

import DefaultLayout from "@/layouts/DefaultLayout.vue";
import Home from "@/pages/Home.vue";

const routes = [
    {
        path: '/',
        component: DefaultLayout,
        children: [
            {path: '', component: Home},
            {path: 'finish-reservation'}
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({el: to.hash});
                }, 1000);
            });
        } else {
            return {top: 0};
        }
    },
})
export default router
